import React from "react";
import styled from "styled-components";
import {
  Container,
  Heading,
  BasicText,
  Highlighter,
  Heading3,
  CodeOuter,
  CodeView,
  LongImage
} from "../styles";
import coverImage from "../assets/coverpage.png";

class ActivityIndicator extends React.Component {
  render() {
    return (
      <Container>
        <Heading>ActivityIndicator</Heading>
        <BasicText>
          The default ActivityIndicator color on Android is
          <Highlighter>#00A18D</Highlighter> and
          <Highlighter>#999999</Highlighter> on IOS. so we normalize it !
        </BasicText>
        <LongImage>
          <img style={{ paddingTop: 15, marginBottom: 20 }} src={coverImage} />
        </LongImage>
        <Heading3>Usage</Heading3>
        <BasicText>
          You just need to import<Highlighter>ActivityIndicator</Highlighter>
          from <b>react-native-normalized</b> instead of <b>react-native!</b>
        </BasicText>
        <CodeOuter>
          <CodeView>
            {
              "import React from 'react';\r\nimport { View } from 'react-native';\r\nimport { ActivityIndicator } from 'react-native-normalized';\r\n\r\nclass Example extends React.Component {\r\n  render(){ \r\n    return(\r\n      <View style={{ flex:1}}>\r\n       <ActivityIndicator/>\r\n     </View>\r\n    )\r\n  }\r\n}"
            }
          </CodeView>
        </CodeOuter>
      </Container>
    );
  }
}

export default ActivityIndicator;
